export default __webpack_public_path__ + "static/media/heartcolor.0cdd73ae.png";